import NiceModal from "@ebay/nice-modal-react";
import FlexChild from "layouts/flex/FlexChild";
import ModalBase from "modals/base/ModalBase";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import style from "./MainDisplayModal.module.css";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import P from "components/P";
import { style as buttonStyle } from "components/buttons/AdminCustomButton";
import { adminRequester } from "App";
import AdminCustomButton from "components/buttons/AdminCustomButton";
const MainDisplayModal = NiceModal.create((props) => {
  const { t } = useTranslation();
  const [withHeader, withFooter] = [true, false];
  const [isMounted, setMounted] = useState(false);
  const [reload, setReload] = useState(false);
  const [discounts, setDiscounts] = useState([]);
  const [width, height] = ["min(95%, 1200px)", "80vh"];
  const withCloseButton = true;
  const modal = useRef();
  const clickOutsideToClose = true;
  const title = "메인진열 관리";
  const buttonText = t("close");
  const [stores, setStores] = useState([]);
  const [store, setStore] = useState();
  const views = ["BEST", "NEW", "RESTOCK", "SUPERDEAL"];
  const [discount, setDiscount] = useState();
  const [products, setProducts] = useState([]);
  const [variants, setVariants] = useState([]);
  useEffect(() => {
    setMounted(true);
  }, []);
  useEffect(() => {
    if (isMounted) {
      adminRequester.getStores({}, (result) => {
        const stores = result.stores;
        setStores(stores);
        if (stores?.length > 0) setStore(stores[0]);
      });
    }
  }, [isMounted]);
  useEffect(() => {
    if (isMounted && store) {
      adminRequester.getDiscountStatus(
        {
          code: views.join(","),
          store_id: store.id,
        },
        (result) => {
          const discounts = result.discounts.map((discount) => {
            if (discount?.rule?.conditions) {
              const reduce = discount?.rule?.conditions.reduce(
                (acc, condition) => {
                  const products =
                    condition?.products && condition?.products?.length > 0
                      ? [...acc.products, ...condition?.products]
                      : acc.products;
                  const variants =
                    condition?.variants && condition?.variants?.length > 0
                      ? [...acc.variants, ...condition?.variants]
                      : acc.variants;
                  return {
                    products: products,
                    variants: variants,
                  };
                },
                { products: [], variants: [] }
              );
              discount.products = reduce.products;
              discount.variants = reduce.variants;
            }
            return discount;
          });
          setDiscounts(discounts);
          const discount = discounts?.[0];
          setDiscount(discount);
          setProducts(discount.products);
          setVariants(discount.variants);
        }
      );
    }
  }, [store]);
  useEffect(() => {
    if (reload) {
      setReload(false);
    }
  }, [reload]);

  return (
    <ModalBase
      borderRadius={"10px"}
      headerStyle
      ref={modal}
      width={width}
      height={height}
      withHeader={withHeader}
      withFooter={withFooter}
      withCloseButton={withCloseButton}
      clickOutsideToClose={clickOutsideToClose}
      title={title}
      buttonText={buttonText}
    >
      <div className={style.wrap}>
        <div className={style.detailContainer}>
          <VerticalFlex flexStart={true} gap={30}>
            <HorizontalFlex justifyContent="space-between">
              <HorizontalFlex
                gap={5}
                width="max-content"
                justifyContent="flex-start"
              >
                {discounts.map((data) => (
                  <FlexChild key={data?.id} width="max-content">
                    <AdminCustomButton
                      style={{
                        backgroundColor: "#ffffff",
                        color: "#000000",
                        fontWeight: "lighter",
                        borderBottom: "0px",
                        borderRadius: "0px",
                        hover: {
                          backgroundColor: "#ffffff",
                          color: "#000000",
                          borderBottom: "1px",
                          borderColor: "gray",
                          borderStyle: "solid",
                          borderRadius: "0px",
                        },
                        selected: {
                          backgroundColor: "#ffffff",
                          color: "#000000",
                          borderBottom: "1px",
                          borderColor: "gray",
                          borderStyle: "solid",
                          borderRadius: "0px",
                        },
                      }}
                      selected={data?.code === discount?.code}
                      onClick={() => {
                        const discount = discounts?.find(
                          (discount) => discount.code === data?.code
                        );
                        setDiscount(discount);
                        setProducts(discount.products);
                        setVariants(discount.variants);
                      }}
                      text={t(data?.title)}
                    />
                  </FlexChild>
                ))}
              </HorizontalFlex>
              <FlexChild width="max-content                                                                                                                                                                                  ">
                <select
                  value={store?.id}
                  onChange={(e) => {
                    const find = stores.find(
                      (store) => store.id === e.target.value
                    );
                    if (find) setStore(find);
                  }}
                >
                  {stores?.map((store) => (
                    <option key={store?.id} value={store.id}>
                      {store?.name}
                    </option>
                  ))}
                </select>
              </FlexChild>
            </HorizontalFlex>
            {discount ? (
              <HorizontalFlex>
                <FlexChild>
                  <VerticalFlex>
                    <HorizontalFlex>
                      <FlexChild />
                      <FlexChild>
                        <AdminCustomButton
                          text="+"
                          style={{
                            fontSize: "0.75rem",
                            width: "1.8rem",
                            height: "1.8rem",
                            textAlign: "center",
                            padding: 5,
                            borderRadius: "100%",
                            hover: {
                              backgroundColor: "#A0A0A0",
                              color: null,
                            },
                          }}
                          onClick={() => {
                            NiceModal.show("adminCheckSelect", {
                              title: "상품 선택",
                              request: (...props) =>
                                adminRequester.getProducts(
                                  ...props.map((p) => {
                                    if (p?.offset || p?.limit) {
                                      return { ...p, store_id: store.id };
                                    }
                                    return p;
                                  })
                                ),
                              code: "products",
                              onSelect: (result) => {
                                const products = [
                                  ...discount.products,
                                  ...result.filter(
                                    (f) =>
                                      !discount.products.some(
                                        (p) => p.id === f.id
                                      )
                                  ),
                                ];
                                setProducts(products);
                                discount.products = products;
                              },
                              headers: [
                                {
                                  code: "thumbnail",
                                  label: "썸네일",
                                  type: "image",
                                  width: "60px",
                                },
                                { code: "id", label: "상품ID" },
                                { code: "title", label: "제목" },
                              ],
                              Search: ({ callback }) => (
                                <input
                                  type="text"
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter")
                                      callback({ t: e.target.value });
                                  }}
                                  style={{
                                    outline: "none",
                                    backgroundColor: "rgb(233, 233, 233)",
                                    borderRadius: "10px",
                                    marginLeft: "auto",
                                    paddingRight: "10px",
                                    paddingLeft: "10px",
                                    minWidth: "250px",
                                  }}
                                  placeholder="search..."
                                />
                              ),
                            });
                          }}
                        />
                      </FlexChild>
                      <FlexChild width="max-content">
                        <AdminCustomButton
                          text="+"
                          style={{
                            fontSize: "0.75rem",
                            width: "1.8rem",
                            height: "1.8rem",
                            textAlign: "center",
                            padding: 5,
                            borderRadius: "100%",
                            hover: {
                              backgroundColor: "#A0A0A0",
                              color: null,
                            },
                          }}
                          onClick={() => {
                            NiceModal.show("adminCheckSelect", {
                              title: "옵션 선택",
                              code: "variants",
                              request: (...props) =>
                                adminRequester.getVariants(
                                  ...props.map((p) => {
                                    if (p?.offset || p?.limit) {
                                      return { ...p, store_id: store.id };
                                    }
                                    return p;
                                  })
                                ),
                              onSelect: (result) => {
                                const variants = [
                                  ...discount.variants,
                                  ...result.filter(
                                    (f) =>
                                      !discount.variants.some(
                                        (v) => v.id === f.id
                                      )
                                  ),
                                ];
                                setVariants(variants);
                                discount.variants = variants;
                              },
                              headers: [
                                {
                                  code: "thumbnail",
                                  label: "썸네일",
                                  type: "image",
                                  width: "60px",
                                },
                                { code: "id", label: "옵션ID" },
                                { code: "title", label: "옵션명" },
                              ],
                              Search: ({ callback }) => (
                                <input
                                  type="text"
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter")
                                      callback({ t: e.target.value });
                                  }}
                                  style={{
                                    outline: "none",
                                    backgroundColor: "rgb(233, 233, 233)",
                                    borderRadius: "10px",
                                    marginLeft: "auto",
                                    paddingRight: "10px",
                                    paddingLeft: "10px",
                                    minWidth: "250px",
                                  }}
                                  placeholder="search..."
                                />
                              ),
                            });
                          }}
                        />
                      </FlexChild>
                    </HorizontalFlex>

                    <HorizontalFlex gap={10}>
                      <div style={{ overflow: "auto", height: "600px" }}>
                        <VerticalFlex height="100%" gap={5}>
                          {products?.length === 0 && (
                            <FlexChild>
                              <P>설정된 상품이 없습니다.</P>
                            </FlexChild>
                          )}
                          {products?.map((product) => (
                            <HorizontalFlex
                              key={product?.id}
                              justifyContent="flex-start"
                              gap={5}
                            >
                              <FlexChild width="max-content">
                                {product?.thumbnail ? (
                                  <img
                                    src={product?.thumbnail}
                                    alt="emtpy"
                                    style={{ width: "5rem", height: "5rem" }}
                                  />
                                ) : (
                                  <div
                                    style={{
                                      width: "5rem",
                                      height: "5rem",
                                      backgroundColor: "white",
                                      border: "1px solid black",
                                    }}
                                  />
                                )}
                              </FlexChild>
                              <VerticalFlex>
                                <FlexChild width="max-content">
                                  <P>{product?.title}</P>
                                </FlexChild>
                                <FlexChild width="max-content">
                                  <AdminCustomButton
                                    text="삭제"
                                    style={{
                                      hover: {
                                        backgroundColor: "#A0A0A0",
                                        color: null,
                                      },
                                    }}
                                    onClick={() => {
                                      const products = [
                                        ...discount.products.filter(
                                          (p) => p.id !== product.id
                                        ),
                                      ];
                                      discount.products = products;
                                      setProducts(products);
                                    }}
                                  />
                                </FlexChild>
                              </VerticalFlex>
                            </HorizontalFlex>
                          ))}
                          {products?.length > 0 &&
                            products?.length < 7 &&
                            [0, 1, 2, 3, 4, 5, 6]
                              .filter(
                                (index) => index >= (products?.length || 0)
                              )
                              .map(() => (
                                <FlexChild>
                                  <P></P>
                                </FlexChild>
                              ))}
                        </VerticalFlex>
                      </div>
                      <FlexChild height="600px" width="min-content">
                        <div className={style.line2} />
                      </FlexChild>
                      <div style={{ overflow: "auto", height: "600px" }}>
                        <VerticalFlex height="100%">
                          {variants?.length === 0 && (
                            <FlexChild>
                              <P>설정된 옵션이 없습니다.</P>
                            </FlexChild>
                          )}
                          {variants?.map((variant) => (
                            <HorizontalFlex
                              key={variant?.id}
                              justifyContent="flex-start"
                              gap={5}
                            >
                              <FlexChild width="max-content">
                                {variant?.thumbnail ? (
                                  <img
                                    src={variant?.thumbnail}
                                    alt="emtpy"
                                    style={{ width: "5rem", height: "5rem" }}
                                  />
                                ) : (
                                  <div
                                    style={{
                                      width: "5rem",
                                      height: "5rem",
                                      backgroundColor: "white",
                                      border: "1px solid black",
                                    }}
                                  />
                                )}
                              </FlexChild>
                              <VerticalFlex>
                                <FlexChild width="max-content">
                                  <P>{variant?.title}</P>
                                </FlexChild>
                                <FlexChild width="max-content">
                                  <AdminCustomButton
                                    text="삭제"
                                    style={{
                                      hover: {
                                        backgroundColor: "#A0A0A0",
                                        color: null,
                                      },
                                    }}
                                    onClick={() => {
                                      const variants = [
                                        ...discount.variants.filter(
                                          (v) => v.id !== variant.id
                                        ),
                                      ];
                                      discount.variants = variants;
                                      setVariants(variants);
                                    }}
                                  />
                                </FlexChild>
                              </VerticalFlex>
                            </HorizontalFlex>
                          ))}
                          {variants?.length > 0 &&
                            variants?.length < 7 &&
                            [0, 1, 2, 3, 4, 5, 6]
                              .filter(
                                (index) => index >= (variants?.length || 0)
                              )
                              .map(() => (
                                <FlexChild>
                                  <P></P>
                                </FlexChild>
                              ))}
                        </VerticalFlex>
                      </div>
                    </HorizontalFlex>
                  </VerticalFlex>
                </FlexChild>
              </HorizontalFlex>
            ) : (
              <P>항목을 선택해주세요</P>
            )}
            <HorizontalFlex justifyContent="center" gap={10}>
              <AdminCustomButton
                style={buttonStyle.white_border}
                text="저장"
                onClick={() => {
                  adminRequester.postDiscountStatus(
                    {
                      discounts: discounts.map((discount) => ({
                        id: discount.id,
                        products: discount?.products,
                        variants: discount?.variants,
                      })),
                      store_id: store.id,
                    },
                    () => modal.current.close()
                  );
                }}
              />
              <AdminCustomButton
                style={buttonStyle.white_border}
                text="취소"
                onClick={() => modal.current.close()}
              />
            </HorizontalFlex>
          </VerticalFlex>
        </div>
      </div>
    </ModalBase>
  );
});

export default MainDisplayModal;
